import { useEffect, useState } from "react";

import { bifrost } from "../../../../assets/bifrost.js";

const emptyTokenInfo = Object.freeze({ category:"", status:"loading" });
const invalidTokenInfo = Object.freeze({ category:"", status:"invalid" });

export const useUnsubscribeTokenInfo = payloadToken=>{
    const [ tokenInfo, setTokenInfo ] = useState(emptyTokenInfo);

    useEffect(_=>{
        let disposed = false;

        setTokenInfo(emptyTokenInfo);
        if (!payloadToken) {
            setTokenInfo(invalidTokenInfo);
            return;
        }

        bifrost.tx("/mail/unsubscribe/info", payloadToken)
            .then(reply=>{
                if (disposed) { return; }
                const next = reply?.error
                    ? invalidTokenInfo
                    : { category:reply.result?.category || "", status:"ready" };
                setTokenInfo(next);
            })
            .catch(err=>{
                if (!disposed) { setTokenInfo(invalidTokenInfo); }
            });

        return _=>{ disposed = true; };
    }, [payloadToken]);

    return tokenInfo;
};
